var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4V7C14.5 7.55228 14.9477 8 15.5 8H18.5M14.5 4H15.0579C15.3395 4 15.6075 4.11861 15.8015 4.32273C16.0931 4.62948 16.5549 5.10178 17 5.5C17.3488 5.8121 17.8968 6.37221 18.225 6.71261C18.4025 6.8967 18.5 7.14249 18.5 7.39819L18.5 8M14.5 4H6.99969M18.5 8L18.4998 19.5M5.49969 9V17.9999C5.49968 19.1045 6.39511 20 7.49968 20H13.9997M19 21L5 3",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.5f7e6f7372d36d24c29270bc4f68537c.svg";
export { ForwardRef as ReactComponent };